import { CustomerIdType } from '../../models/customer/idType';

export const CustomerAction = {
    SetCustomerDetail: 'SET_CUSTOMER_DETAIL',
    SetAcceptDisclaimer: 'SET_ACCEPT_DISCLAIMER',
    SetOtpData: 'SET_OTP_DATA',
};

export interface CustomerSetCustomerDetail {
    type: typeof CustomerAction.SetCustomerDetail,
    value: { id: string, type: CustomerIdType, mobileNumber: string, token: string, reference: string },
}

export interface CustomerAcceptDisclaimer {
    type: typeof CustomerAction.SetAcceptDisclaimer,
    value: { isAccept: boolean },
}

export interface CustomerSetOtpData {
    type: typeof CustomerAction.SetOtpData,
    value: { token: string, reference: string },
}

export type CustomerActions =
    CustomerSetCustomerDetail |
    CustomerAcceptDisclaimer |
    CustomerSetOtpData;
